import React, { useEffect } from "react";
import isEmpty from "lodash/isEmpty";

import Spinner, { styles } from "components/Spinner";
import { PAYMENT_TYPES } from "utils/constants";

import PaymentUpdateCardStripeCheckout from "../PaymentUpdateCardStripeCheckout";
import PaymentUpdateAdyenDropIn from "../PaymentUpdateCardAdyenDropIn";

function PaymentUpdateForm(props) {
  const {
    isFetchingPaymentDetails,
    paymentDetails,
    saveAndGetPaymentCardDetails,
    orderSessionToken,
    webTxnId
  } = props;
  const loading = isEmpty(paymentDetails) || isFetchingPaymentDetails;

  useEffect(() => {
    if (!isFetchingPaymentDetails) {
      saveAndGetPaymentCardDetails({
        // for Payload Action
        paymentMethod: "card",
        txn_id: webTxnId,
        uuid: webTxnId,
        token: orderSessionToken,
        additional_data: {
          custom_payment_method: "card"
        },
        notification_channel: {},
        instrument_data: {
          redirect_url: window.location.href
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!loading) {
    const type = paymentDetails?.gateway || "";
    const paymentComponents = {
      [PAYMENT_TYPES.STRIPE]: PaymentUpdateCardStripeCheckout,
      [PAYMENT_TYPES.ADYEN]: PaymentUpdateAdyenDropIn
    };
    const PaymentForm = paymentComponents[type] || null;

    return <PaymentForm {...props} />;
  }

  return <Spinner size={200} sx={styles.modalContainer} />;
}

export default PaymentUpdateForm;
